export default __webpack_public_path__ + "assets/png/f63971d2c21efe7c1ad1cbf39083f340.png";